import MyMatchesPage from "@/pages/MyMatchesPage";

export default function MatchProgramsPage() {
  return <MyMatchesPage basePath="/account/matches" savedDetailBasePath="/account/matches/saved" showTitle={false} showTutorial />;
}
